import { BlobEntityType } from "./enums/blobentitytype";

export class StagedBlob {
        public blobStagingId: number;
        public entityType: BlobEntityType;
        public entityId: number;
        public fileName: string;
        public createdByName: string;
        public createdUtcDate: string;
        public attachmentTypeId: number;
    }